import { useState } from 'react'
import { Grid, Button, Typography } from '@material-ui/core'

import { useSnackbar } from 'hooks'

import { EditCommisionDialog } from '../'
import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from 'components/Table'
import { MenuButton } from 'components'

import helpers from 'helpers'
import sellerConstant from 'constants/seller'

import * as service from 'service'

const ListCommision = ({
  commisions,
  refresh,
  refreshSeller,
  disabled,
  setLoading,
}) => {
  const snackbar = useSnackbar()
  const [openEdit, setOpenEdit] = useState(false)
  const [data, setData] = useState({})

  const handleRemove = async (commisionId) => {
    setLoading(true)
    try {
      await service.dponet.transferCommisions.destroy({
        transferCommisionId: commisionId,
      })
      snackbar.open({
        message: 'Comissão removida com sucesso!',
        variant: 'success',
      })
      refresh()
    } catch (error) {
      snackbar.open({
        message: helpers.formatters.errorMessage(
          error?.response?.data?.error ||
            'Ocorreu um erro ao remover a comissão',
        ),
        variant: 'error',
      })
    } finally {
      refreshSeller()
      setLoading(false)
    }
  }

  const handleOpenEdit = (commision) => {
    setOpenEdit(true)
    setData(commision)
  }

  const formatValue = (kind, value) =>
    helpers.sellers.defaultValues(kind, value, 0, true)

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        {commisions?.length === 0 ? (
          <Typography variant="body2" color="textSecondary">
            Nenhuma comissão cadastrada para este vendedor.
          </Typography>
        ) : (
          <Table>
            <TableHead>
              <TableRow>
                <TableCell width={disabled ? '15%' : '10%'}>ID</TableCell>
                <TableCell width="15%">De</TableCell>
                <TableCell width="15%">Até</TableCell>
                <TableCell width="15%">Porcentagem</TableCell>
                <TableCell width="20%">Nível</TableCell>
                <TableCell width={disabled ? '20%' : '15%'}>Tipo</TableCell>
                {!disabled && (
                  <TableCell width="10%" align="right">
                    Ações
                  </TableCell>
                )}
              </TableRow>
            </TableHead>
            <TableBody>
              {commisions?.map((commision) => (
                <TableRow key={commision?.id}>
                  <TableCell disableTooltip>#{commision?.id}</TableCell>
                  <TableCell disableTooltip>
                    {formatValue(commision?.kind, commision?.rangeFrom)}
                  </TableCell>
                  <TableCell disableTooltip>
                    {formatValue(commision?.kind, commision?.rangeTo)}
                  </TableCell>
                  <TableCell disableTooltip>{commision?.percentage}%</TableCell>
                  <TableCell disableTooltip>{commision?.level}</TableCell>
                  <TableCell disableTooltip>
                    {sellerConstant.LABEL_KINDS[commision?.kind]}
                  </TableCell>
                  {!disabled && (
                    <TableCell disableTooltip align="right">
                      <MenuButton>
                        <>
                          <Button
                            onClick={() => handleOpenEdit(commision)}
                            fullWidth
                            size="small"
                          >
                            Editar
                          </Button>
                          <Button
                            onClick={() => handleRemove(commision?.id)}
                            fullWidth
                            size="small"
                          >
                            Excluir
                          </Button>
                        </>
                      </MenuButton>
                    </TableCell>
                  )}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </Grid>
      {openEdit && (
        <EditCommisionDialog
          open={openEdit}
          commision={data}
          setOpen={setOpenEdit}
          refresh={refresh}
          refreshSeller={refreshSeller}
        />
      )}
    </Grid>
  )
}

export default ListCommision
